import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/compensation/messages";
import { camelizeKeys } from "lib/helpers";

function* getLedgerCsvReport(action) {
  const { reportId } = action.payload;
  const { success, data, error } = yield* makeRequest.get(`/reports/${reportId}`);
  if (success && data) {
    yield put(actions.setEnterpriseApplicationsCSV(camelizeKeys(data.body.report)));
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_LEDGER_CSV,
    });
  }
  return null;
}

export default getLedgerCsvReport;
